module.exports = __webpack_public_path__ + "img/refresh.b33f1af5.svg";